import { Box, Button, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { UseFormGetValues } from 'react-hook-form'
import InfoIcon from '@mui/icons-material/Info';
import { ButtonLoading } from '../../../../../theme/buttons';
import { Project } from '../../../../../interfaces/Projects/projects';

type ConfirmDialogProps = {
  isEdit: boolean,
  loadingPut: boolean,
  setDialogConfirmUncheckTask: Dispatch<SetStateAction<boolean>>,
  projectTaskName: string | undefined,
  handleTaskCompletion: () => void
}

export const ConfirmDialog = ({
  isEdit,
  loadingPut,
  setDialogConfirmUncheckTask,
  projectTaskName,
  handleTaskCompletion
}: ConfirmDialogProps) => {
  const [t] = useTranslation("global");
  const [projectName, setProjectName] = useState<string>();
  const [isEqualName, setEqualName] = useState(false);

  const handleChange = (e: any) => {
    const value = e.target.value;
    setProjectName(value);
    if (projectTaskName === value) {
      setEqualName((prev) => true);
    }
    else {
      setEqualName(false);
    }
  }

  return (
    <Box display={"flex"} flexDirection={"column"} justifyContent={"start"} width={"100%"}>
      <Box width={"100%"} marginBottom={2}>
        <Typography margin={1}>{t("projecttaskdashboard.info.confirm-uncheck-task")}</Typography>
        <Typography margin={1}><InfoIcon /> {t("projecttaskdashboard.info.uncheck-warning")} ({projectTaskName})</Typography>
        <TextField
          value={projectName}
          variant='outlined'
          size='small'
          onChange={handleChange}
          label={t("projecttasks.fields.project_task_name")}
          required
          fullWidth
        />
      </Box>
      <Box display={"flex"} flexDirection={"row-reverse"} width={"100%"} gap={1}>
        <ButtonLoading disabled={isEdit || !isEqualName} isLoading={loadingPut} onClick={() => { handleTaskCompletion(); setDialogConfirmUncheckTask(false); }} className="d-flex align-self-end" variant="outlined">{t("generic.buttons.accept")}</ButtonLoading>
        <Button variant='outlined' onClick={() => { setDialogConfirmUncheckTask(false) }} disabled={loadingPut}>{t("generic.buttons.goback")}</Button>
      </Box>
    </Box>
  )
}
